module.exports = __webpack_public_path__ + "img/2_3.2f050b91.png";